module.exports = __webpack_public_path__ + "static/undraw_website_setup_5hr2-7550d87f405830c724af264a6932b381.svg";